import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Authenticator from '../../shared/Authenticator';
import * as serviceWorker from './serviceWorker';
import App from "./App";
import Appstream from "./Appstream";
import {
  BrowserRouter as Router, Route, Switch
} from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <Authenticator
      renderApp={() =>
        window.location.pathname == '/stream'
          ?
          <Router>
            <Route path={`/:id`}>
              <Appstream></Appstream>
            </Route>
          </Router>
          :
          <App />
      } />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
